import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"

export async function getEndPoints() {
  const endpointApi = "/system/endpoints";
  let endpoints = []

  await axios
    .get(endpointApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("endpointNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.endpoints != undefined) {
        endpoints = response.data.endpoints
      }
    })

  return endpoints
}

export async function addEndpoint(url) {
  const endpointApi = "/system/endpoints";

  let data = {};

  if (url != null) {
    data.url = url
  }

  await axios
    .post(endpointApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("endpointNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function updateEndpoint(data) {
  const endpointApi = "/system/endpoints";
  await axios
    .put(endpointApi, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error =>{
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("endpointNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    }))

}

export async function removeEndpoints(endpoints) {
  const endpointApi = "/system/endpoints";

  let deleteArray = [];

  endpoints.forEach((endpoint) => {
    deleteArray.push(endpoint._id);
  });

  let data = {};
  if (deleteArray.length > 0) {
    data.endpoints = deleteArray;
  }

  await axios
    .delete(endpointApi, { data: data })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("endpointNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}
